export const BR1201EventsRecord = [
    /**
     * @event 'Survey_show_referral_pop_up'
     */
    {
        eventName: 'Survey_show_referral_pop_up',
        description: 'Показ шторки/поп-аппа при прохождении опроса',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Survey_close_referral_pop_up'
     */
    {
        eventName: 'Survey_close_referral_pop_up',
        description: 'Нажатие на крестик, закрывающий шторку/поп-апп, при прохождении опроса',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Survey_how_does_it_work_referral_pop_up'
     */
    {
        eventName: 'Survey_how_does_it_work_referral_pop_up',
        description: 'Нажатие на кнопку “Как это работает?” в поп-аппе/шторке при прохождении опроса',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Survey_close_how_does_it_work_referral_pop_up'
     */
    {
        eventName: 'Survey_close_how_does_it_work_referral_pop_up',
        description: 'Нажатие на крестик, закрывающий шторку/поп-апп "Как это работает?" при прохождении опроса',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Survey_ok_how_does_it_work_referral_pop_up'
     */
    {
        eventName: 'Survey_ok_how_does_it_work_referral_pop_up',
        description: 'Нажатие на "Ок" закрывающий шторку/поп-апп "Как это работает?" при прохождении опроса',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Survey_share_a_link_referral_pop_up'
     */
    {
        eventName: 'Survey_share_a_link_referral_pop_up',
        description: 'Нажатие на кнопку "Поделиться ссылкой" при прохождении опроса',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_show_referral_pop_up'
     */
    {
        eventName: 'After_five_orders_show_referral_pop_up',
        description: 'Показ шторки/поп-аппа на главной/меню/лк',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_close_referral_pop_up'
     */
    {
        eventName: 'After_five_orders_close_referral_pop_up',
        description: 'Нажатие на крестик, закрывающий шторку/поп-апп, на главной/меню/лк',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_how_does_it_work_referral_pop_up'
     */
    {
        eventName: 'After_five_orders_how_does_it_work_referral_pop_up',
        description: 'Нажатие на кнопку “Как это работает?” в поп-аппе/шторке на главной/меню/лк',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_close_how_does_it_work_referral_pop_up'
     */
    {
        eventName: 'After_five_orders_close_how_does_it_work_referral_pop_up',
        description: 'Нажатие на крестик, закрывающий шторку/поп-апп "Как это работает?" на главной/меню/лк',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_ok_how_does_it_work_referral_pop_up'
     */
    {
        eventName: 'After_five_orders_ok_how_does_it_work_referral_pop_up',
        description: 'Нажатие на "Ок"  закрывающий шторку/поп-апп "Как это работает?" на главной/меню/лк',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_share_a_link_referral_pop_up'
     */
    {
        eventName: 'After_five_orders_share_a_link_referral_pop_up',
        description: 'Нажатие на кнопку "Поделиться ссылкой" на главной/меню/лк',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_show_referral_banner'
     */
    {
        eventName: 'After_five_orders_show_referral_banner',
        description: 'Показ баннера в ЛК',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_show_referral_banner'
     */
    {
        eventName: 'After_five_orders_click_referral_banner',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_close_referral_pop_up_from_banner'
     */
    {
        eventName: 'After_five_orders_close_referral_pop_up_from_banner',
        description: 'Нажатие на крестик, закрывающий шторку/поп-апп, баннера в ЛК',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_how_does_it_work_referral_pop_up_from_banner'
     */
    {
        eventName: 'After_five_orders_how_does_it_work_referral_pop_up_from_banner',
        description: 'Нажатие на кнопку “Как это работает?” в поп-аппе/шторке баннера в ЛК',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_close_how_does_it_work_referral_pop_up_from_banner'
     */
    {
        eventName: 'After_five_orders_close_how_does_it_work_referral_pop_up_from_banner',
        description: 'Нажатие на крестик, закрывающий шторку/поп-апп "Как это работает?" баннера в ЛК',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_ok_how_does_it_work_referral_pop_up_from_banner'
     */
    {
        eventName: 'After_five_orders_ok_how_does_it_work_referral_pop_up_from_banner',
        description: 'Нажатие на "Ок"  закрывающий шторку/поп-апп "Как это работает?" баннера в ЛК',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_close_referral_banner'
     */
    {
        eventName: 'After_five_orders_close_referral_banner',
        description: 'Нажатие на крестик у баннера в ЛК мобилки',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'After_five_orders_share_a_link_referral_pop_up_from_banner'
     */
    {
        eventName: 'After_five_orders_share_a_link_referral_pop_up_from_banner',
        description: 'Нажатие на кнопку "Поделиться ссылкой" баннера в ЛК',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
];
